<template>
  <div>
    <div>
      <h2>{{$translate('Settings for mobile application')}}</h2>
    </div>
    <div v-if="isZMB">
      <!-- Easy and flex, choose to use MyBusiness or Old in expo app -->
      <div>
        <v-switch
          v-model="isFlex"
          :label="$translate('Present app as MyBusiness')">
        </v-switch>
      </div>
      <!-- Flex options, choose homepage in expo app -->
      <div v-if="isZMB == 'flex' && isFlex">
        <v-select
          v-model="selectedSite"
          :items="sortedSites"
          item-text="title"
          label="Select"
          persistent-hint
          return-object
          single-line>
        </v-select>
      </div>
      <!-- Save and show page -->
      <div class="d-flex">
        <v-spacer />
        <v-btn class="zoezi-button-thin mx-2" color="zoezi-edit-color" :disabled="!changed" @click="save" :loading="saving">{{$translate('Save')}}</v-btn>
        <v-btn class="zoezi-button-thin mx-2" color="zoezi-edit-color" outlined @click="showPage">{{$translate('Show the page')}}</v-btn>
      </div>
    </div>
    <v-snackbar
      v-model="alert.show"
      :timeout="alert.timeout"
      :color="alert.success ? 'success' : 'error'"
      bold
    >
      <strong>{{ $translate(alert.success ? 'Settings saved' : 'Failed to save settings') }}</strong>
      <template v-slot:action="{ attrs }">
        <v-btn
            :color="$store.state.snackBar.color"
            text
            v-bind="attrs"
            class="zoezi-button-thin"
            @click="alert.show = false"
        >
            {{$translate('Close')}}
        </v-btn>
        </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "zoezi-exposettings",
  zoezi: {
    icon: "mdi-cogs",
    title: "Mobile App Settings",
  },
  data: () => ({
    oldOption: null,
    sortedSites: [],
    selectedSite: null,
    isFlex: false,
    saving: false,
    alert: {
      show: false,
      timeout: 2000,
      success: true
    }
  }),
  methods: {
    getSortedSites() {
      return this.$root.sites?.filter((s) => s.shared == false)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((s) => {s.title = `${s.name} (${s.basepath})`; return s}) || [];
    },
    showPage() {
      if (!this.isFlex)
        window.open('/member', '_blank')?.focus();
      else
        window.open(this.selectedSite?.basepath, '_blank')?.focus();
    },
    save(){
      this.saving = true;
      const path = this.isFlex ? this.selectedSite.basepath : 'legacy';
      this.$api.post('/api/settings/app/homepage',null, {path}).then((item) => {
        this.saving = false;
        if (item.status == 200){
          this.alert.success = true;
        }
        else {
          this.alert.success = false;
        }
          
      }).catch(() => {
        this.alert.success = false;
      }).finally(() => {
        this.alert.show = true;
        this.fetchSettings();
      });
    },
    fetchSettings() {
      this.$api.get('/api/settings/app/get').then(settings => {
        if(settings.zoezimybusinesshomepage){
          if (settings.zoezimybusinesshomepage == 'legacy'){
            this.selectedSite = this.sortedSites[0];
            this.oldOption = 'legacy';
          } else {
            this.isFlex = true;
            this.selectedSite = this.sortedSites.find(site => site.basepath == settings.zoezimybusinesshomepage);
            this.oldOption = this.selectedSite;
          }
        }
        else {
          this.selectedSite = this.sortedSites[0]
          this.oldOption = this.selectedSite;
        }
      });
    }
  },
  computed: {
    isZMB() {
      return this.$store.state.settings?.zoeziMyBusiness || false;
    },
    changed(){
      if (this.oldOption == 'legacy'){
        return this.isFlex;
      }
      return (this.selectedSite && this.selectedSite != this.oldOption) || !this.isFlex;
    }
  },
  mounted() {
    this.$root.loadSites().then(() => {
      this.sortedSites = this.getSortedSites();
      this.sortedSites.unshift({title: 'Standard (/)', basepath: '/', });
      this.fetchSettings();
    });
  }
};
</script>